module.exports = __webpack_public_path__ + "static/media/Configuración_Usuarios.58004ade.svg";